import { useTranslation } from 'react-i18next'
import { useGetAttractivenessDropdownOptions } from '../AttractivenessForm/hooks/useGetAttractivenessDropdownOptions'
import { IAttractivenessResponseValue } from '../@types/IAttractivenessTileData'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useSelectedSettings = (data: IAttractivenessResponseValue) => {
  const {
    businessTypeOptions,
    ageBucketOptions,
    trafficTypeOptions,
    transportMeansOptions,
    daypartOptions,
    weekpartOptions,
    marketTypeOptions,
  } = useGetAttractivenessDropdownOptions()
  const { t } = useTranslation()
  if (!data) return []

  const { settings } = data.attractiveness

  const settingsList = [{
    label: t('placeme.attractiveness.section.market_type.title'),
    value: marketTypeOptions.find(option => option.value === settings.market)!.label,
    visible: true,
  },
  {
    label: t('placeme.attractiveness.business_type'),
    value: businessTypeOptions.find(option => option.value === settings.businessType)!.label,
    visible: true,
  },
  {
    label: t('placeme.attractiveness.age_buckets'),
    value: ageBucketOptions.filter(choice =>
      settings.ageBuckets?.find((item: string) => item === choice?.value))
      ?.map(choice => choice?.label)
      ?.join(', '),
    visible: true,
  },
  {
    label: t('placeme.attractiveness.traffic_type'),
    value: trafficTypeOptions.find(option => option.value === settings.traffic.type)!.label,
    visible: true,
  },
  {
    label: t('placeme.attractiveness.transport_means'),
    value: transportMeansOptions.find(option => option.value === settings.transportMeans)!.label,
    visible: true,
  },
  {
    label: t('placeme.attractiveness.dayparts'),
    value: daypartOptions.filter(choice =>
      settings.traffic.dayparts?.find((item: string) => item === choice?.value))
      ?.map(choice => choice?.label)
      ?.join(', '),
    visible: true,
  },
  {
    label: t('placeme.attractiveness.weekparts'),
    value: weekpartOptions.filter(choice =>
      settings.traffic.weekparts?.find((item: string) => item === choice?.value))
      ?.map(choice => choice?.label)
      ?.join(', '),
    visible: true,
  },
  ]

  return settingsList
}
